import React, {Component} from 'react';
import PropTypes from 'prop-types';
import FileViewerModal from "./FileViewerModal";
import BackEnd from "../backend/BackEnd";

class ImageViewerModal extends Component {
    static propTypes = {
        documentId: PropTypes.number,
        allowDownload: PropTypes.bool,
        onHide: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {};

    render() {
        return (
            <FileViewerModal {...this.props}
                             requireToken={false}
                             createUrl={() => (new BackEnd.ViewImage.View()).createUrl({imageId: this.props.documentId})}
                             viewer={url => (
                                 <div style={{overflow: 'scroll'}}>
                                     <img src={url}/>
                                 </div>
                             )}/>
        );
    }
}

export default ImageViewerModal;


// WEBPACK FOOTER //
// ./src/modals/ImageViewerModal.js